import { useMemo } from 'react';
import { getCurrentUser } from '@/services/ws-permissions/src/main/resources/rest-api/index.ts';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useNavigate } from '@/js/libs/router/index.ts';
import { useLazyRequest } from '@/js/libs/use-request/index.ts';
import { useAuth } from '../../authContext.js';
import useTokenStorage from '../useTokenStorage.js';
export const useGetIdentity = ({ onSuccess, onFail } = {}) => {
    const { getAuthToken } = useTokenStorage();
    const { identity: { loading, initialized }, setIdentity, } = useAuth();
    const navigate = useNavigate();
    const getCurrentUserRequest = useLazyRequest({
        apiMethod: getCurrentUser,
        onSuccess: ({ data: user }) => {
            onSuccess?.(user);
            setIdentity({
                user,
                loading: false,
                initialized: true,
            });
            if (initialized) {
                navigate('/');
            }
        },
        onFail: (error) => {
            setIdentity(({ user }) => ({
                user,
                loading: false,
                initialized: true,
            }));
            onFail?.(error);
        },
    });
    const getIdentity = useCallbackRef((userParams = {}) => {
        setIdentity((prevState) => ({
            ...prevState,
            loading: true,
        }));
        const accessToken = getAuthToken();
        if (!accessToken) {
            setIdentity({
                user: undefined,
                loading: false,
                initialized: true,
            });
            return Promise.resolve(undefined);
        }
        return getCurrentUserRequest.load(userParams).then((response) => response.data);
    });
    return useMemo(() => ({
        getIdentity,
        loading,
        initialized,
    }), [getIdentity, loading, initialized]);
};
